module.exports = __webpack_public_path__ + "img/solution23.24d9b7e1.png";